import { defineComponent as _defineComponent } from 'vue'
import { defineComponent } from 'vue';
import { testAxios } from '@/api/test';
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { ElMessageBox } from 'element-plus';
import { ajax } from '@/api';
import { Cookies } from '@/utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, { expose: __expose }) {
  __expose();

const drawer = ref(false);
const drawer2 = ref(false);
const direction = ref('rtl');
const radio1 = ref('Option 1');
const handleClose = (done: () => void) => {
	ElMessageBox.confirm('Are you sure you want to close this?')
		.then(() => {
			done();
		})
		.catch(() => {
			// catch error
		});
};

onMounted(() => {
	var div = document.querySelector('.touch-demo');
	// 获取手指初始坐标和盒子的原来位置
	var startX = 0;
	var startY = 0;
	// 获取盒子原来的位置
	var x = 0;
	var y = 0;
	div.addEventListener('touchstart', function (e) {
		console.log('start事件');
		// 得到初始的手指坐标
		startX = e.targetTouches[0].pageX;
		startY = e.targetTouches[0].pageY;
		// 获取盒子坐标
		x = this.offsetLeft;
		y = this.offsetTop;
	})
	div.addEventListener('touchmove', function (e) {
		// 手指的移动距离= 手指移动之后的坐标 - 手指初始的坐标
		var moveX = e.targetTouches[0].pageX - startX;
		var moveY = e.targetTouches[0].pageY - startY;
		// 移动盒子，盒子原来的位置+手指移动的距离
		this.style.left = x + moveX + 'px';
		this.style.top = y + moveY + 'px';
		// 阻止屏幕滚动行为
		e.preventDefault();
	})

	div.addEventListener('touchend', function (e) {
		console.log('end事件');
		
		this.style.left = '0';
		// this.style.top = y + 'px';
	})
});

onBeforeUnmount(() => { });

function cancelClick() {
	drawer2.value = false;
}
function confirmClick() {
	ElMessageBox.confirm(`Are you confirm to chose ${radio1.value} ?`)
		.then(() => {
			drawer2.value = false;
		})
		.catch(() => {
			// catch error
		});
}
function do_test() {
	drawer.value = true;
}

async function test_laravel() {
	const res: any = await ajax({
		headers: {
			// 'X-XSRF-TOKEN': Cookies.get('XSRF-TOKEN')
		},
		url: 'http://laravel.cc:81/d3',
		data: {
			page: 1,
		},
	});
	console.log(res.data.list);
}

const __returned__ = { drawer, drawer2, direction, radio1, handleClose, cancelClick, confirmClick, do_test, test_laravel }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})